import { table } from './_table';

export const requests = {
  namespaced: true,
  modules: {
    table
  }
};
